import React, { lazy, Suspense } from 'react'

import { LAZY_CONTAINER_LOAD_DELAY } from '@/config'
import Nothing from '@/generic/components/Nothing'

const Lazy = lazy(() => new Promise((resolve) => {
  // delay loading until page has been rendered as the container is not
  // needed initially
  setTimeout(() => {
    resolve(import('./ShareContainer'))
  }, LAZY_CONTAINER_LOAD_DELAY)
}))

const LazyShareContainer = (props) => (
  <Suspense fallback={<Nothing />}>
    <Lazy {...props} />
  </Suspense>
)

export default LazyShareContainer
